// Use to download 1 file ONLY
const downloadFile = (fileUrl: string) => {
  const downloadLink = document.createElement('a')

  downloadLink.href = fileUrl
  downloadLink.click()
  downloadLink.remove()
}

const downloadAllMedia = (imageUrls: string[]) => {
  imageUrls.forEach((imageUrl, index) => {
    // Without a delay between downloads
    // Chrome downloads only the first file
    setTimeout(() => downloadFile(imageUrl), index * 500)
  })
}

export { downloadAllMedia, downloadFile }
